module.exports = __webpack_public_path__ + "static/customer-experience-71e52fdf75f2554096fa23c31711c855.png";